import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NavBarModule from './NavBar/NavBarModule';
import { server, logData } from '../api.js';
import { useAuth } from '../useAuth';
import '../index.css';

function ModuleList() {
  const [prompt, setPrompt] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [pendingModule, setPendingModule] = useState(null);
  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    const rc = auth.getResearchCode();
    logData(rc, 'MODULE_LIST_LOADED', {});
  }, []);

  const fetchPrompt = async (moduleId) => {
    const rc = auth.getResearchCode();
    logData(rc, 'MODULE_SELECTED', { module: moduleId });

    try {
      const response = await fetch(`${server}/get_prompt?module=module${moduleId}`);
      const data = await response.json();
      if (data.prompt) {
        setPrompt(data.prompt);
        localStorage.setItem('modulePrompt', data.prompt);
      } else {
        console.error("Prompt not found for the selected module.");
      }
    } catch (error) {
      console.error('Error fetching the prompt:', error);
    }
  };

  const confirmModuleNavigation = async (moduleId, moduleName) => {
    await fetchPrompt(moduleId);
    localStorage.setItem('selectedModule', moduleName);
    navigate('/pathwayselection');
  };

  const handleModuleClick = (moduleId, moduleName) => {
    // Check if it's a partially working module (not generating student-facing materials)
    if (moduleId === 5) {
      setPendingModule({ id: moduleId, name: moduleName });
      setShowModal(true);
    } else {
      confirmModuleNavigation(moduleId, moduleName);
    }
  };

  const handleModalYes = () => {
    if (pendingModule) {
      confirmModuleNavigation(pendingModule.id, pendingModule.name);
    }
    setShowModal(false);
    setPendingModule(null);
  };

  const handleModalNo = () => {
    setShowModal(false);
    setPendingModule(null);
  };

  return (
    <div className="row flex-nowrap">
      <NavBarModule />
      <div className="col py-3">
        <div className="text-center">
          <img src={require("../assets/images/conjurorlogo.png")} className="w-25 mb-5" alt="logo" />
        </div>

        <div className="container w-75">
          <h5 className="fw-bold">Which module are you teaching?</h5>
          <p className="mb-4">Choose the module you would like to customize:</p>
        </div>

        <div className="container d-grid gap-2">
          <div className="row justify-content-md-center">
            <div className="col-sm-4">
              {/* <div role="button" onClick={() => handleModuleClick(1, 'Scratch Basics')}> */}
              <div role="button">
                <div className="image-container">
                  <img src={require("../assets/images/thumbnailM1.png")} alt="module 1" className="img-thumbnail" />
                  <div className="overlay">Under Construction</div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div role="button" onClick={() => handleModuleClick(2, 'Events')}>
                <img src={require("../assets/images/thumbnailM2.png")} alt="module 2" className="img-thumbnail" />
              </div>
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-sm-4">
              <div role="button" onClick={() => handleModuleClick(3, 'Animation')}>
                <img src={require("../assets/images/thumbnailM3.png")} alt="module 3" className="img-thumbnail" />
              </div>
            </div>
            <div className="col-sm-4">
              <div role="button" onClick={() => handleModuleClick(4, 'Conditional Loops')}>
                <img src={require("../assets/images/thumbnailM4.png")} alt="module 4" className="img-thumbnail" />
              </div>
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-sm-4">
              <div role="button" onClick={() => handleModuleClick(5, 'Decomposition by Sequence')}>
                <div className="image-container">
                  <img src={require("../assets/images/thumbnailM5.png")} alt="module 5" className="img-thumbnail" />
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              {/* <div role="button" onClick={() => handleModuleClick(6, 'One-Way Synchronization')}> */}
              <div role="button">
                <div className="image-container">
                  <img src={require("../assets/images/thumbnailM6.png")} alt="module 6" className="img-thumbnail" />
                  <div className="overlay">Under Construction</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Confirmation Modal */}
        {showModal && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Heads Up!</h5>
                  <button type="button" className="btn-close" onClick={handleModalNo}></button>
                </div>
                <div className="modal-body">
                  <p>
                    Conjuror currently does NOT generate student-facing materials for this module.
                    <strong> We can send you an generic template to edit. </strong>
                    Do you still wish to proceed?
                  </p>
                </div>
                <div className="modal-footer d-flex justify-content-between">
                  <button onClick={handleModalYes} className="btn btn-primary me-2 flex-fill">
                    Yes, continue with this module
                  </button>
                  <button onClick={handleModalNo} className="btn btn-secondary flex-fill">
                    No, choose another module
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default ModuleList;